import TableStyle from "../style/table.component";
import { Header } from "./interface/interface";

interface GroupProps {
  selectedIds: string[];
  setSelectedIds: (value: any[]) => void;
  headers: Header[];
  dataList: any[];
}
const ChecksTable = (props: GroupProps) => {
  const { headers, setSelectedIds, selectedIds, dataList } = props;

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const list = [...selectedIds];
    if (selectedIds.includes(e.target.value)) {
      const newList = list.filter((item) => item !== e.target.value);
      setSelectedIds(newList);
      return;
    }

    list.push(e.target.value);
    setSelectedIds(list);
  };

  return (
    <TableStyle
      marginTop="30px"
      width="90%"
      style={{ height: "200px", overflowY: "auto", display: "block" }}
    >
      <thead>
        <tr>
          <th></th>
          {headers.map((header: Header, index: number) => (
            <th key={header.value}>{header.text}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {dataList.map((data: any, index: number) => (
          <tr key={index}>
            <td>
              <input
                type="checkbox"
                name="selectRow"
                value={index}
                onChange={handleRadioChange}
                checked={selectedIds.includes(String(index))}
              />
            </td>
            {headers.map((header, index: number) =>
              header.value === "data.name" ? (
                <td key={header.value}>{data["data"].name}</td>
              ) : (
                <td key={header.value}>{data[header.value]}</td>
              ),
            )}
          </tr>
        ))}
      </tbody>
    </TableStyle>
  );
};

export default ChecksTable;
